export const FEATURE_FLAGS: string[] = ["evBatteryExplainerCopy"];
